export const initialState = {
    loading: 'idle',
    error: null,
};
